import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../wrapper";
import { logInUserInfo } from "../../Actions/Users";
// import PaymentList from '../../Components/Payment'
import { PaymentList } from "../../Components/NewPayment";
import ConfirmDialoag from "../../Components/common/ConfirmDialoag";

import axios from "axios";
import instance from "../../axios";
import withRoutes from "../../HOC/HocRoutes";
import moment from "moment";
import { callActiveInactiveCron } from "../../Helpers";
import WorkshopAddPayment from "../../Components/WorkshopPayment/AddPayment";
import Table from "../../Components/common/tableWithBackEndPagination";
import Loader from "../../Layout/Loader";
import TextField from "../../Components/common/TextField";
import Button from "../../Components/common/Button";
import SingleSelect from "../../Components/common/SingleSelect";
import { Grid } from "@mui/material";

let source;
const formDefault = {
  id: 0,
  attributes: {},
  refNum: "",
  type: true,
  amount: "",
  contractNumber: "",
  paymentMode: "",
  paymentDate: "",
  remarks: "",
  adjustmentType: "",
  parentId: 0,
  receipt: "",
  docs: " ",
  archive: null,
  archiveTime: null,
  recipientDate: "",
  invoiceIds: [],
  searchAccount: "",
  useCredit: false,
};
const formDefaultSettleAmount = {
  contractNumberForSettle: "",
  garageIdForSettle: "",
  adjustAmount: 0,
  adjustmentType: "",
  invoiceIds: [],
};

const resolveGarageName = (item = {}) =>
  item.garageName ||
  item.attributes?.garageName ||
  item.attributes?.customerName ||
  item.customerName ||
  item.name ||
  "";

const normalizeGaragePayments = (payload) => {
  if (!payload) return payload;
  if (Array.isArray(payload)) {
    return payload.map((item) => ({
      ...item,
      garageName: resolveGarageName(item),
    }));
  }
  if (Array.isArray(payload.data)) {
    return {
      ...payload,
      data: payload.data.map((item) => ({
        ...item,
        garageName: resolveGarageName(item),
      })),
    };
  }
  return payload;
};
class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      payments: "",
      paymentList: "",
      form: { ...formDefault },
      formSettleAmount: { ...formDefaultSettleAmount },
      selectedPayment: "",
      editOption: false,
      onDeleteConfirmation: false,
      itemAttributes: {},
      selectedGroup: "",
      isVisableAddBtn: false,
      isVisableSettleBtn: false,
      isVisable: false,
      activeOperation: "",
      selectedItem: "",
      openTable: false,
      users: "",
      addOption: false,
      to: "",
      from: "",
      account: "",
      vehcile: "",
      area: "",
      filteredData: false,
      selectedAccount: {},
      page: 1,
      pageSize: 20,
      loader: true,
      showPayments: false,
      openFilter: false,
      searchPayment: "",
      selectSingleAccount: false,
      paymentAccount: "",
      manualPayments: "",
      isChecked: false,
      selectedInvoices: [],
      totalInvoiceBalance: 0,
      // objects: [],
      creditAmount: "",
      creditAmountForSettle: "",
      contractType: 1,
      loader2: false,
      balanceError: "",
      // invoiceIds:[]
      invoiceLoader: false,
      invoiceSearch: "",
      paymentNumber: "",
      refNumber: "",
      settleAmountOption: false,
      overallInvoiceBalance: "",
      onSettleAmountConfirmation: false,
      garageData: {},
      searchGarageText: "",
      loader1: false,
      garageCity: "",
      garageType: "",
      selectedGarageCity: "",
      isVisableFilterBtn: false,
      enableReset: false,
      // settlementForm: {
      //   adjustAmount: 0,
      //   adjustmentType: "",
      //   invoiceIds: "",
      // },
    };
    this.modalControle = this.modalControle.bind(this);
    this.addDevice = this.addDevice.bind(this);
  }
  componentDidMount() {
    this.getGaragesData();
  }

  allUsersId = (event, items) => {
    // for selecting single Invoice
    let allData = [];
    let totalBalance;
    // const roundedNum = Math.round(num * 100) / 100;
    if (event.target.checked) {
      let ids = Array.isArray(this.state.form.invoiceIds)
        ? [...this.state.form.invoiceIds, items.id]
        : [items.id];
      let cal = this.state.totalInvoiceBalance + items.invoicebalance;
      totalBalance = Math.round(cal * 100) / 100;
      this.setState(
        {
          totalInvoiceBalance: totalBalance,
          form: {
            ...this.state.form,
            invoiceIds: ids,
          },
        },
        () => this.checkRequiredFields()
      );
    } else {
      let ids = Array.isArray(this.state.form.invoiceIds)
        ? this.state.form.invoiceIds.filter((id) => id !== items.id)
        : [];
      let cal = this.state.totalInvoiceBalance - items.invoicebalance;
      totalBalance = Math.round(cal * 100) / 100;
      this.setState(
        {
          totalInvoiceBalance: totalBalance,
          form: {
            ...this.state.form,
            invoiceIds: ids,
          },
        },
        () => this.checkRequiredFields()
      );
    }

    this.state.manualPayments.map((it) => {
      if (it.id === items.id) {
        let row = {
          ...it,
          check: event.target.checked,
        };
        allData.push(row);
      } else {
        allData.push(it);
      }
    });

    this.setState({ manualPayments: allData }, () =>
      this.checkRequiredFields()
    );
  };

  selectAll = (e) => {
    let allData = [];
    let totalBalance;
    let ids = [];
    let cal = 0;
    this.state.manualPayments.map((it) => {
      let row = {
        ...it,
        check: e,
      };
      if (e) {
        cal = cal + it.invoicebalance;
        ids.push(it.id);
      } else {
        cal = 0;
        ids = [];
      }
      allData.push(row);
    });
    totalBalance = Math.round(cal * 100) / 100;
    this.setState(
      {
        totalInvoiceBalance: totalBalance,
        form: {
          ...this.state.form,
          invoiceIds: ids,
        },
      },
      () => this.checkRequiredFields()
    );
    this.setState(
      { manualPayments: allData, totalInvoiceBalance: totalBalance },
      () => this.checkRequiredFields()
    );
  };

  searchInvoices = (e) => {
    source.cancel();
    this.setState(
      {
        invoiceSearch: e.target.value,
      },
      () => {
        this.getInvoicesForSingleAccount();
      }
    );
  };
  getInvoicesForSingleAccount = () => {
    const { paymentAccount, selectedAccount, showPayments } = this.state;
    let url;
    let account;
    if (showPayments) {
      account = selectedAccount;
    } else {
      account = paymentAccount;
    }

    const garageId = account?.garageId || account?.id || "";
    url = `api/garageinvoices/unpaid/list?garageId=${garageId}&invoiceNumber=${this.state.invoiceSearch}`;
    source = axios.CancelToken.source();

    // this.setState({
    //   invoiceLoader : true,
    // },()=>{
    axios
      .get(url, {
        cancelToken: source.token,
      })
      .then((res) => {
        const filteredInvoices = res?.data?.data?.filter(
          (invoice) => invoice.invoicebalance > 0
        );
        let totalInvBalance = res?.data?.data?.reduce(
          (sum, item) => sum + item.invoicebalance,
          0
        );
        this.setState(
          {
            manualPayments: (filteredInvoices || []).map((invoice) => ({
              ...invoice,
              garageName:
                resolveGarageName(invoice) ||
                account?.name ||
                account?.accountName ||
                account?.label ||
                "",
            })),
            // isChecked: true,
            overallInvoiceBalance: totalInvBalance,
            invoiceLoader: false,
          },
          () => {
            this.checkRequiredFields();
            this.checkRequiredFields1();
          }
        );
      })
      .catch((error) => {
        // errorHandler(error, this.props.dispatch)
      });
    // })
  };

  getCredtit = () => {
    const { paymentAccount, selectedAccount, showPayments, searchAccount } =
      this.state;

    let account;
    let url;
    if (showPayments) {
      account = selectedAccount;
    } else {
      account = paymentAccount;
    }

    const garageId = account?.garageId || account?.id || "";
    url = `api/garagepayments/credit?garageId=${garageId}`;

    instance({
      method: "GET",
      url: url,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        this.setState({
          creditAmount: res,
          // isChecked: true,
        });
        this.setState({ creditAmountForSettle: res }, () => {
          this.checkRequiredFields();
          this.checkRequiredFields1();
        });
      })
      .catch((error) => {
        // errorHandler(error, this.props.dispatch)
      });
  };

  handleChangeForAccount = async (name, event, link) => {
    this.setState(
      {
        [name]: event,
        form: {
          ...this.state.form,
          contractNumber: event?.contractNumber || "",
          garageId: event?.garageId || event?.id || "",
          useCredit: true,
          invoiceLoader: true,
        },
      },
      () => {
        this.getInvoicesForSingleAccount();
        this.getCredtit();
        this.checkRequiredFields();
      }
    );
    // this.props.handleChange('useCredit')(event);
  };

  handleChange = (name) => (event) => {
    if (name === "useCredit") {
      if (event.target.checked) {
        this.setState((prevState) => ({
          form: {
            ...this.state.form,
            useCredit: true,
          },
        }));
      } else {
        this.setState((prevState) => ({
          form: {
            ...this.state.form,
            useCredit: false,
          },
        }));
      }
    } else if (name === "adjustmentType") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: event.target.value,
          },
          invoiceLoader: event.target.value === "manual" ? true : false,
        },
        () => {
          this.checkRequiredFields();
          if (event.target.value === "manual") {
            this.getInvoicesForSingleAccount();
          }
        }
      );
    } else {
      let value =
        name === "amount" ? parseFloat(event.target.value) : event.target.value;

      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: value,
          },
        },
        () => this.checkRequiredFields()
      );
    }
  };

handleSubmit = async (event) => {
  let { form, selectedAccount } = this.state;
  const obj = { ...form };

  try {
    const result = await axios.post(`/api/garagepayments`, obj);
    if (result.data.status === "success") {
      this.setState(
        {
          addOption: false,
          editOption: false,
          isVisableAddBtn: false,
          paymentAccount: "",
          totalInvoiceBalance: "",
          form: {
            refNum: "",
            amount: "",
            paymentMode: "",
            paymentDate: "",
            remarks: "",
            adjustmentType: "",
            recipientDate: "",
            contractNumber: "",
          },
          // selectedAccount: {},
        },
        () => {
          this.getPaymentList()
const cn = result?.data?.data?.contractNumber;

if (cn && typeof cn === "string" && cn.trim() !== "") {
  callActiveInactiveCron(cn);
}

        }
      );

      toast.success(this.props.translate("paymentAdded"));
    } else {
      let message = result?.data?.message||"Something went wrong";
      const splitString = message.split(": ");
      if (splitString.length >= 2) {
        message = splitString[1];
      }
      toast.error(this.props.translate(message));
    }
  } catch (error) {
    console.warn("Payment submit error:", error?.message || error);
    toast.error(this.props.translate("somethingWentWrong"));
  }
};


  getAccounts = () => {
    if (this.props.logInUser && this.props.logInUser.id) {
      instance({
        method: "GET",
        url: `api/accounts/get?userId=${this.props.logInUser.id}&all=true&limit=20&page=1`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          this.setState({
            users: res.data,
          });
        })
        .catch((error) => {
          // errorHandler(error, this.props.dispatch)
        });
    }
  };
  //
  // handleChangeLicenseExpDate = (name, event) => {
  //   if (name === "paymentDate" || name === "recipientDate") {
  //     const dateValue = event ? event.toISOString() : null;
  //     this.setState(
  //       {
  //         form: {
  //           ...this.state.form,
  //           [name]: dateValue,
  //         },
  //       },
  //       () => this.checkRequiredFields()
  //     );
  //   }
  // };

  handleChangeLicenseExpDate = (name, event) => {
    let serverTimeZone = "";
    if (
      this.props.logInUser &&
      this.props.logInUser.attributes &&
      this.props.logInUser.attributes.timezone
    ) {
      serverTimeZone = this.props.logInUser.attributes.timezone;
    } else {
      serverTimeZone = "Asia/Riyadh";
    }

    // if (name === "paymentDate" || name === "recipientDate") {
    //   const dateValue = event
    //     ? moment.tz(event, serverTimeZone).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
    //     : null;
    //   this.setState(
    //     {
    //       form: {
    //         ...this.state.form,
    //         [name]: dateValue,
    //       },
    //     },
    //     () => this.checkRequiredFields()
    //   );
    // }

    if (name === "paymentDate" || name === "recipientDate") {
      const dateValue = event
        ? moment(event).endOf("day").utc().format("YYYY-MM-DDT00:00:00.000[Z]")
        : null;
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: dateValue,
          },
        },
        () => this.checkRequiredFields()
      );
    }
  };

  updatePayment = async () => {
    const { selectedPayment, form } = this.state;
    const obj = { ...form };
    let result = await axios.put(`/api/payments/${selectedPayment.id}`, obj);
    if (result.data.status === "success") {
      this.setState({
        addOption: false,
        editOption: false,
        isVisableAddBtn: false,
      });

      toast.success(this.props.translate("Payment Updated"));
    } else {
      toast.error(this.props.translate(result.data.message));
    }
  };

  deletePayment = async () => {
    const { selectedPayment } = this.state;
    let result = await axios.delete(`/api/payments/${selectedPayment.id}`);
    if (result.data.status === "success") {
      // this.getFilteredPAyments(this.state.to,this.state.from,this.state.account,this.state.vehcile,this.state.area)

      toast.success(this.props.translate("Payment Deleted"));
    } else {
      toast.error(this.props.translate(result.data.message));
    }
  };

  addDevice() {
    this.setState({
      // pageSize:-1,
      addOption: true,
    });
  }

  paymentSelection = async (item) => {
    if (item) {
      const payment = {
        ...item[0],
        garageName: resolveGarageName(item[0]),
      };
      await this.setState({
        // defaultDeviceList: false,
        selectedPayment: payment,
        editOption: true,
        form: { ...payment },
      });
    }
  };

  onCancel = () => {
    this.setState({
      onDeleteConfirmation: false,
    });
  };
  // componentDidMount() {
  //   this.getAccounts();
  // }
  componentWillUnmount() {
    if (source) {
      source.cancel();
    }
  }

  checkFloteNumber(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  setPagination = (items) => {
    let nItem = { ...items };
    let lastPage = nItem.total / this.state.pageSize;
    let IsFloate = this.checkFloteNumber(lastPage);
    delete nItem.data;
    nItem.pageSize = this.state.pageSize;
    nItem.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
    return nItem;
  };
  getSelectedGarageId = () =>
    this.state.selectedAccount?.garageId || this.state.selectedAccount?.id || "";

  getGaragesData = () => {
    const { page, pageSize, searchGarageText, garageCity, garageType } = this.state;
    const apiUrl = `/api/garages/get?userId=${this.props.logInUser?.id}&all=true&page=${page}&limit=${pageSize}&search=${searchGarageText}${
      garageCity ? `&garageCity=${garageCity}` : ""
    }${garageType ? `&garageType=${garageType}` : ""}`;
    source = axios.CancelToken.source();
    this.setState({ loader1: true }, () => {
      axios
        .get(apiUrl, {
          cancelToken: source.token,
        })
        .then((response) => {
          this.setState({
            garageData: response?.data?.data || {},
            loader1: false,
            enableReset: this.state.isVisableFilterBtn ? true : false,
          });
        })
        .catch(() => {
          this.setState({ loader1: false });
        });
    });
  };

  searchGarage = (e) => {
    source?.cancel?.();
    this.setState(
      {
        searchGarageText: e.target.value,
        page: 1,
      },
      () => this.getGaragesData()
    );
  };
  checkSearchFields = () => {
    const { garageCity, garageType } = this.state;
    this.setState({
      isVisableFilterBtn: Boolean(garageCity || garageType),
    });
  };
  searchGarageFilters = (e, name) => {
    source?.cancel?.();
    if (name === "garageType") {
      this.setState({ garageType: e.target.value }, () => this.checkSearchFields());
    } else if (e === "garageCity") {
      this.setState(
        { garageCity: name?.id || "", selectedGarageCity: name || "" },
        () => this.checkSearchFields()
      );
    } else {
      this.searchGarage(e);
    }
  };
  getGarages = () => {
    this.setState({ enableReset: true, page: 1 }, () => this.getGaragesData());
  };
  resetGarages = () => {
    this.setState(
      {
        garageCity: "",
        garageType: "",
        selectedGarageCity: "",
        isVisableFilterBtn: false,
        enableReset: false,
        page: 1,
      },
      () => this.getGaragesData()
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    if (this.state.filteredData || this.state.openFilter) {
      this.setState({ page: 1, pageSize: rowsPerPage }, () => {
        this.getFilteredPAyments(
          this.state.to,
          this.state.from,
          this.state.account,
          this.state.vehcile,
          this.state.area
        );
      });
    } else {
      this.setState({ page: 1, pageSize: rowsPerPage }, () => {
        this.getGaragesData();
      });
    }
  };

  handleChangePage = (value) => {
    if (this.state.filteredData || this.state.openFilter) {
      this.setState({ page: value }, () => {
        this.getFilteredPAyments(
          this.state.to,
          this.state.from,
          this.state.account,
          this.state.vehcile,
          this.state.area
        );
      });
    } else {
      this.setState({ page: value }, () => {
        this.getGaragesData();
      });
    }
  };
  openFilters = (type) => {
    this.setState(
      {
        to: "",
        from: "",
        account: "",
        vehcile: "",
        area: "",
        openFilter: true,
        showPayments: false,
        filteredData: false,
        form: {
          contractNumber: this.props?.ServerSetting?.contractNumber,
        },
        selectedAccount: this.props?.ServerSetting,
      },
      () =>
        this.getFilteredPAyments(
          this.state.to,
          this.state.from,
          this.state.account,
          this.state.vehcile,
          this.state.area,
          type
        )
    );
  };

  paymentFilter = async (to, from, account, vehcile, area) => {
    this.setState(
      {
        // selectedAccount:item,
        to: to,
        from: from,
        account: account,
        vehcile: vehcile,
        area: area,
        page: 1,
        pageSize: 20,
        itemSearch: "",
        filteredData: true,
      },
      () => {
        this.getFilteredPAyments(to, from, account, vehcile, area);
      }
    );
  };

downloadInvoices = async (to, from, account, vehicle, area, type) => {
  try {
    const contractNumber = this.state.showPayments
      ? `&cn=${this.state.form.contractNumber}`
      : account
      ? account
      : "";

    const accept =
      type === "downloadPdf"
        ? "application/pdf"
        : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    const headers = new Headers({
      "Content-Type": "application/json",
      Accept: accept,
    });

    const response = await fetch(
      `/api/payments/export?to=${to}&from=${from}${contractNumber}`,
      {
        method: "GET",
        headers,
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `Request failed with status ${response.status}`);
    }

    const blob = await response.blob();
    const fileName = type === "downloadPdf" ? "payments.pdf" : "payments.xlsx";

    this.setState(
      {
        selectedAreaId: "",
        selectedvehicleId: "",
        to: "",
        from: "",
        loader: false,
      },
      () => {
        this.saveData(blob, fileName);
      }
    );
  } catch (error) {
    console.error("Download invoices failed:", error);
    this.setState({ loader: false }); // ensure loader resets even on error
  }
};


  saveData = (blob, filename) => {
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      const a = document.createElement("a");
      document.body.appendChild(a);
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = filename;
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        // this.setState({ loading: false })
      }, 0);
    }
    // this.setState({ loading: false })
  };
  getSearchedPayments = () => {
    this.setState({
page:1,
    },()=>{
      this.getFilteredPAyments(
        this.state.to,
        this.state.from,
        this.state.account,
        this.state.vehcile,
        this.state.area,
        ""
      );
    })

  };

  getFilteredPAyments = (to, from, account, vehcile, area, type) => {
    let {
      page,
      pageSize,
      searchPayment,
      contractType,
      showPayments,
      selectedAccount,
      paymentNumber,
      refNumber,
    } = this.state;
    let apiUrl;
    const garageId = selectedAccount?.garageId || selectedAccount?.id || "";
    const selectedKey = garageId
      ? `garageId=${garageId}`
      : `cn=${selectedAccount?.contractNumber || ""}`;
    if (showPayments) {
      // inCase of selecting single account/workshop
      if (to) {
        apiUrl = `/api/garagepayments/get?${selectedKey}&to=${to}&from=${from}${account}${vehcile}${area}&page=${page}&limit=${pageSize}&paymentNumber=${paymentNumber}&refNumber=${refNumber}`;
      } else {
        apiUrl = `/api/garagepayments/get?${selectedKey}&page=${page}&limit=${pageSize}&paymentNumber=${paymentNumber}&refNumber=${refNumber}`;
      }
    } else {
      if (to) {
        apiUrl = `/api/garagepayments/get?&contractType=${contractType}&to=${to}&from=${from}${account}${vehcile}${area}&page=${page}&limit=${pageSize}&paymentNumber=${paymentNumber}&refNumber=${refNumber}`;
      } else {
        apiUrl = `/api/garagepayments/get?page=${page}&limit=${pageSize}&paymentNumber=${paymentNumber}&refNumber=${refNumber}`;
      }
    }
    source = axios.CancelToken.source();
    this.setState(
      {
        loader2: true,
      },
      () => {
        axios
          .get(apiUrl, {
            cancelToken: source.token,
          })
          .then((response) => {
            this.setState({
              filteredData: true,
              paymentList: normalizeGaragePayments(response?.data?.data || []),
              openTable: true,
              loader: false,

              loader2: false,
            });
          })
          .catch((e) => {
            // console.log("e ===", e);
          });
      }
    );
  };

  SearchItem = (e, name) => {
    source.cancel();
    if (this.state.filteredData || this.state.openFilter) {
      if (name === "paymentNumber" || name === "refNumber") {
        this.setState(
          {
            [name]: e.target.value,
          }
          // () =>
          //   this.getFilteredPAyments(
          //     this.state.to,
          //     this.state.from,
          //     this.state.account,
          //     this.state.vehcile,
          //     this.state.area,
          //     ""
          //   )
        );
      }
    } else {
      this.setState(
        {
          searchPayment: e.target.value,
        },
        () => {
          this.getPaymentList();
        }
      );
    }
  };

  getPaymentList = () => {
    let { page, pageSize, searchPayment } = this.state;
    // &search=${searchPayment}
    let apiUrl;
    source = axios.CancelToken.source();

    const selectedGarageId = this.getSelectedGarageId();
    apiUrl = selectedGarageId
      ? `/api/garagepayments/get?garageId=${selectedGarageId}&page=${page}&limit=${pageSize}&search=${searchPayment}`
      : `/api/garagepayments/get?page=${page}&limit=${pageSize}&search=${searchPayment}`;
    this.setState(
      {
        loader: true,
      },
      () => {
        axios
          .get(apiUrl, {
            cancelToken: source.token,
          })
          .then((response) => {
            this.setState({
              payments: normalizeGaragePayments(response?.data?.data || []),
              // paymentList: result.data.data,
              filteredData: false,
              openTable: true,
              loader: false,
            });
          })
          .catch((e) => {
            // console.log("e ===", e);
          });
      }
    );
  };



  setContractType = (value) => {
    this.setState({
      contractType: value,
    });
  };

  setDefaultForm = () => {
    const selectedGarageId = this.getSelectedGarageId();
    this.setState({
      form: {
        contractNumber: this.state.showPayments
          ? this.state.form.contractNumber
          : "",
        garageId: this.state.showPayments ? selectedGarageId : "",
        // ...formDefault,
      },
      // formSettleAmount: {},
      // paymentAccount: "",
      // isVisableSettleBtn: false,
      creditAmountForSettle: "",
      overallInvoiceBalance: "",
    });
  };
  //  --------------------------------------Settelemt Settings-------------------------------------------------------------

  settleAmount = () => {
    this.setState({
      settleAmountOption: true,
    });
  };

  afterSettleOpen = () => {
    const selectedGarageId = this.getSelectedGarageId();
    if (!this.state.showPayments || !selectedGarageId) {
      return;
    }
    this.setState(
      {
        formSettleAmount: {
          ...formDefaultSettleAmount,
          garageIdForSettle: selectedGarageId,
          contractNumberForSettle:
            this.state.selectedAccount?.contractNumber || "",
        },
        paymentAccount: {
          ...this.state.selectedAccount,
          id: selectedGarageId,
          garageId: selectedGarageId,
          label:
            this.state.selectedAccount?.name ||
            this.state.selectedAccount?.accountName ||
            this.state.selectedAccount?.label ||
            "",
          name:
            this.state.selectedAccount?.name ||
            this.state.selectedAccount?.accountName ||
            "",
        },
      },
      () => {
        this.getInvoicesForSingleAccount();
        this.getCredtit();
      },
    );
  };

  allUsersId1 = (event, items) => {
    // for selecting single Invoice
    let allData = [];
    let totalBalance;
    // const roundedNum = Math.round(num * 100) / 100;
    if (event.target.checked) {
      let ids = Array.isArray(this.state.formSettleAmount.invoiceIds)
        ? [...this.state.formSettleAmount.invoiceIds, items.id]
        : [items.id];
      let cal = this.state.totalInvoiceBalance + items.invoicebalance;
      totalBalance = Math.round(cal * 100) / 100;
      this.setState(
        {
          totalInvoiceBalance: totalBalance,
          formSettleAmount: {
            ...this.state.formSettleAmount,
            invoiceIds: ids,
          },
        },
        () => this.checkRequiredFields1()
      );
    } else {
      let ids = Array.isArray(this.state.formSettleAmount.invoiceIds)
        ? this.state.formSettleAmount.invoiceIds.filter((id) => id !== items.id)
        : [];
      let cal = this.state.totalInvoiceBalance - items.invoicebalance;
      totalBalance = Math.round(cal * 100) / 100;
      this.setState(
        {
          totalInvoiceBalance: totalBalance,
          formSettleAmount: {
            ...this.state.formSettleAmount,
            invoiceIds: ids,
          },
        },
        () => this.checkRequiredFields1()
      );
    }

    this.state.manualPayments.map((it) => {
      if (it.id === items.id) {
        let row = {
          ...it,
          check: event.target.checked,
        };
        allData.push(row);
      } else {
        allData.push(it);
      }
    });

    this.setState({ manualPayments: allData }, () =>
      this.checkRequiredFields1()
    );
  };

  selectAll1 = (e) => {
    let allData = [];
    let totalBalance;
    let ids = [];
    let cal = 0;
    this.state.manualPayments.map((it) => {
      let row = {
        ...it,
        check: e,
      };
      if (e) {
        cal = cal + it.invoicebalance;
        ids.push(it.id);
      } else {
        cal = 0;
        ids = [];
      }
      allData.push(row);
    });
    totalBalance = Math.round(cal * 100) / 100;
    this.setState(
      {
        totalInvoiceBalance: totalBalance,
        formSettleAmount: {
          ...this.state.formSettleAmount,
          invoiceIds: ids,
        },
      },
      () => this.checkRequiredFields1()
    );
    this.setState(
      { manualPayments: allData, totalInvoiceBalance: totalBalance },
      () => this.checkRequiredFields1()
    );
  };

  modalControle() {
    this.setState({
      isVisableAddBtn: false,
      addOption: false,
      editOption: false,
      settleAmountOption: false,
      totalInvoiceBalance: "",
      selectedInvoices: "",
      // form: {
      //   ...this.state.form,
      //   contractNumber: this.state.form.contractNumber
      //     ? this.state.form.contractNumber
      //     : "",
      // },
      pageSize: 20,
      // selectedAccount: type,
    });
  }

  goBack = () => {
    this.setState({
      addOption: false,
      settleAmountOption: false,
      editOption: false,
      showPayments: false,
      openFilter: false,
      totalInvoiceBalance: 0,
      selectedInvoices: "",
      form: "",
      paymentNumber: "",
      refNumber: "",
      searchPayment: "",
      pageSize: 20,
    });
  };

  checkRequiredFields = () => {
    const {
      refNum,
      amount,
      paymentMode,
      adjustmentType,
      recipientDate,
      paymentDate,
      contractNumber,
      garageId,
      invoiceIds,
    } = this.state.form;

    if (
      refNum &&
      amount &&
      paymentMode &&
      adjustmentType &&
      recipientDate &&
      paymentDate &&
      (contractNumber || garageId) &&
      amount
    ) {
      // if (adjustmentType === "manual") {
      //   if (invoiceIds?.length > 0) {
      //     this.setState({ isVisableAddBtn: true });
      //   } else {
      //     this.setState({ isVisableAddBtn: false });
      //   }
      // } else {
      this.setState({ isVisableAddBtn: true, balanceError: "" });
      // }
    } else {
      this.setState({ isVisableAddBtn: false, balanceError: "" });
    }
  };

  singlePaymentSelection = (type) => {
    // console.log("paymentAccount=====", type);
    const selectedGarageId = type?.garageId || type?.id || "";
    this.setState(
      {
        to: "",
        from: "",
        account: selectedGarageId ? `&garageId=${selectedGarageId}` : type?.contractNumber,
        vehcile: "",
        area: "",
        openFilter: false,
        showPayments: true,
        filteredData: false,
        form: {
          contractNumber: type?.contractNumber || "",
          garageId: selectedGarageId,
        },
        selectedAccount: { ...type, garageId: selectedGarageId },
        formSettleAmount: {
          ...formDefaultSettleAmount,
          garageIdForSettle: selectedGarageId,
          contractNumberForSettle: type.contractNumber || "",
        },
        // paymentAccount: type,
        // isVisableSettleBtn: true,
      },
      () => {
        this.getFilteredPAyments(
          this.state.to,
          this.state.from,
          this.state.account,
          this.state.vehcile,
          this.state.area,
          type
        );
        this.checkRequiredFields();
        this.checkRequiredFields1();
      }
    );
  };

  checkRequiredFields1 = () => {
    const {
      contractNumberForSettle,
      garageIdForSettle,
      adjustAmount,
      adjustmentType,
      invoiceIds,
    } = this.state.formSettleAmount;
    const { creditAmountForSettle, overallInvoiceBalance } = this.state;
    const hasSettleTarget = garageIdForSettle || contractNumberForSettle;

    if (
      hasSettleTarget &&
      creditAmountForSettle &&
      overallInvoiceBalance
    ) {
      if (adjustmentType === "manual") {
        if (
          adjustAmount <= creditAmountForSettle &&
          adjustAmount <= overallInvoiceBalance &&
          adjustAmount > 0 &&
          invoiceIds?.length > 0
        ) {
          this.setState({ isVisableSettleBtn: true });
        } else {
          this.setState({ isVisableSettleBtn: false });
        }
      } else {
        this.setState({ isVisableSettleBtn: true });
      }
    } else {
      this.setState({ isVisableSettleBtn: false });
    }
  };
  handleChangeSettleAmount = (name, event) => {
    if (event) {
      if (name === "adjustAmount" || name === "adjustmentType") {
        this.setState(
          {
            formSettleAmount: {
              ...this.state.formSettleAmount,
              [name]: event.target.value,
            },
            // isVisableSettleBtn: true,
          },
          () => {
            this.checkRequiredFields1();
            // this.getInvoicesForSingleAccount();
            // this.getCredtit();
          }
        );
      } else {
        const garageId = event?.garageId || event?.id || "";
        this.setState(
          {
            [name]: event,
            formSettleAmount: {
              ...this.state.formSettleAmount,
              garageIdForSettle: garageId,
              contractNumberForSettle: event.contractNumber || "",
            },
            // isVisableSettleBtn: true,
          },
          () => {
            this.checkRequiredFields1();
            this.getInvoicesForSingleAccount();
            this.getCredtit();
          }
        );
      }
    } else {
      this.setDefaultForm();
    }
  };

  onCancelSettle = () => {
    this.setState({ onSettleAmountConfirmation: false });
  };
  onOKSettle = () => {
    this.setState({ onSettleAmountConfirmation: false }, () => {
      this.handleSubmitSettleAmount();
    });
  };
  onConfirmSettle = () => {
    this.setState({ onSettleAmountConfirmation: true });
  };
  handleSubmitSettleAmount = async () => {
    const { formSettleAmount } = this.state;
    const {
      contractNumberForSettle,
      garageIdForSettle,
      adjustmentType,
      adjustAmount,
      invoiceIds,
    } = formSettleAmount;

    const garageId =
      garageIdForSettle ||
      this.state.paymentAccount?.garageId ||
      this.state.paymentAccount?.id ||
      this.getSelectedGarageId();

    let url;

    // Conditional URL construction based on adjustmentType
    if (adjustmentType === "manual") {
      const invoiceIdsParam = invoiceIds
        ?.map((id) => `invoiceIds=${id}`)
        ?.join("&");
      url = `/api/garagepayments/settle?garageId=${garageId}&adjustAmount=${adjustAmount}&${invoiceIdsParam}`;
    } else if (adjustmentType === "fifo") {
      url = `/api/garagepayments/settle?garageId=${garageId}`;
    }
    instance({
      method: "GET",
      url: url,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        // Reset form and state
        this.setState({
          form: {
            ...formDefault,
            contractNumber: this.state.showPayments
              ? this.state.form.contractNumber
              : "",
            garageId: this.state.showPayments ? this.getSelectedGarageId() : "",
          },
          formSettleAmount: { ...formDefaultSettleAmount },
          paymentAccount: "",
          isVisableSettleBtn: false,
          creditAmountForSettle: "",
          overallInvoiceBalance: "",
          settleAmountOption: false,
        });
        if (contractNumberForSettle) {
          callActiveInactiveCron(contractNumberForSettle);
        }
        toast.success(this.props.translate("settledAmountSuccessful"));
        if (this.state.showPayments || this.state.openFilter) {
          this.getFilteredPAyments(
            this.state.to,
            this.state.from,
            this.state.account,
            this.state.vehcile,
            this.state.area,
          );
        }
      })
      .catch((error) => {
        // Handle and display error message
        let result1;
        const splitString = (error.message || "").split(": ");
        if (splitString.length >= 2) {
          result1 = splitString[1]; // Take the second part after splitting
        }

        toast.error(this.props.translate(result1 || "somethingWentWrong"));
      });
  };

  render() {
    if (this.props.logInUser) {
      return (
        <Layout
          {...this.state}
          {...this.props}
          paymentFilter={this.paymentFilter}
          downloadInvoices={this.downloadInvoices}
          noSidebar={
            this.state.openFilter || this.state.showPayments ? "" : "noSidebar"
          }
        >
          {!this.state.showPayments && !this.state.openFilter ? (
            <>
              <Grid container className="breadcrumb-row">
                <Grid item xs={12} sm={3}>
                  <h3 style={{ margin: 0 }}>
                    {this.props.translate("workshopPayment")}
                  </h3>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={9}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <div style={{ width: "25%", marginRight: 20 }}>
                    <SingleSelect
                      array={this.props.cities || []}
                      async
                      selectName="garageCity"
                      isClearable
                      label={this.props.translate("workshopCity")}
                      value={
                        this.state.selectedGarageCity
                          ? {
                              id: this.state.selectedGarageCity?.id,
                              value:
                                this.state.selectedGarageCity?.cityEn ||
                                this.state.selectedGarageCity?.name,
                              label:
                                this.state.selectedGarageCity?.cityEn ||
                                this.state.selectedGarageCity?.name,
                            }
                          : ""
                      }
                      hidebg
                      handleChange={this.searchGarageFilters}
                      canAssign
                      menuPlacement="auto"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                  <div style={{ width: "25%", marginRight: 20 }}>
                    <TextField
                      fullWidth
                      label={this.props.translate("workshopType")}
                      value={this.state.garageType}
                      onChange={(e) => this.searchGarageFilters(e, "garageType")}
                    />
                  </div>
                  <div style={{ width: "15%", marginRight: 20 }}>
                    <Button
                      aria-label="search"
                      size="small"
                      color="inherit"
                      disabled={!this.state.isVisableFilterBtn}
                      onClick={this.getGarages}
                      id="search"
                    >
                      {this.props.translate("search")}
                    </Button>
                  </div>
                  <div style={{ width: "15%", marginRight: 20 }}>
                    <Button
                      aria-label="reset"
                      size="small"
                      color="inherit"
                      disabled={!this.state.enableReset}
                      onClick={this.resetGarages}
                      id="reset"
                    >
                      {this.props.translate("reset")}
                    </Button>
                  </div>
                  <div style={{ width: "15%", marginRight: 10, marginTop: 6 }}>
                    <Button
                      aria-label="all-payments"
                      size="small"
                      color="inherit"
                      onClick={() => this.openFilters(this.state.contractType)}
                    >
                      {this.props.translate("allPayments")}
                    </Button>
                  </div>
                  <div style={{ width: "25%" }}>
                    <TextField
                      fullWidth
                      label={this.props.translate("search")}
                      value={this.state.searchGarageText || ""}
                      onChange={(e) => this.searchGarageFilters(e)}
                    />
                  </div>
                </Grid>
              </Grid>
              {this.state.loader1 ? (
                <Loader />
              ) : (
                <Table
                  rows={(this.state.garageData && this.state.garageData.data) || []}
                  pagination={this.setPagination(this.state.garageData || {})}
                  handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                  handleChangePage={this.handleChangePage}
                  onClick={this.singlePaymentSelection}
                  rowsPerPage={15}
                  translate={this.props.translate}
                  isCursoPointer
                  rowDefinition={[
                    { id: "name", label: this.props.translate("name") },
                    { id: "garageNumber", label: this.props.translate("workshopNumber") },
                    { id: "garageArea", label: this.props.translate("workshopArea") },
                    { id: "garageManager", label: this.props.translate("workshopManager") },
                    { id: "email", label: this.props.translate("email") },
                    { id: "phone", label: this.props.translate("sharedPhone") },
                  ]}
                />
              )}
            </>
          ) : null}
          {this.state.showPayments || this.state.openFilter ? (
          <PaymentList
            {...this.state}
            {...this.props}
            garagePayments
            AddPaymentComponent={WorkshopAddPayment}
            allUsersId1={this.allUsersId1}
            selectAll1={this.selectAll1}
            getSearchedPayments={this.getSearchedPayments}
            searchInvoices={this.searchInvoices}
            users={this.state.users}
            payments={this.state.payments}
            paymentList={
              this.state.openFilter || this.state.filteredData
                ? this.state.paymentList
                : this.state.payments
            }
            setDefaultForm={this.setDefaultForm}
            goBack={this.goBack}
            setContractType={this.setContractType}
            selectAll={this.selectAll}
            SearchItem={this.SearchItem}
            addDevice={this.addDevice}
            addOption={this.state.addOption}
            settleAmount={this.settleAmount}
            afterSettleOpen={this.afterSettleOpen}
            settleAmountOption={this.state.settleAmountOption}
            handleSubmit={this.handleSubmit}
            data={this.state.form}
            handleChangeForAccount={this.handleChangeForAccount}
            handleChange1={this.handleChangeSettleAmount}
            handleSubmitSettleAmount={this.onConfirmSettle}
            creditAmountForSettle={this.state.creditAmountForSettle}
            overallInvoiceBalance={this.state.overallInvoiceBalance}
            allUsersId={this.allUsersId}
            handleChange={this.handleChange}
            editOption={this.state.editOption}
            paymentSelection={this.paymentSelection}
            selectedPayment={this.state.selectedPayment}
            updatePayment={this.updatePayment}
            removeEnable={this.removeEnable}
            onDeleteConfirmation={this.state.onDeleteConfirmation}
            modalControle={this.modalControle}
            deletePayment={this.deletePayment}
            onCancel={this.onCancel}
            // editEnable={this.editEnable}
            setPagination={this.setPagination}
            isVisableAddBtn={this.state.isVisableAddBtn}
            isVisableSettleBtn={this.state.isVisableSettleBtn}
            checkRequiredFields={this.checkRequiredFields}
            handleChangeLicenseExpDate={this.handleChangeLicenseExpDate}
            handleChangePage={this.handleChangePage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            selectedAccount={this.state?.selectedAccount || {}}
            showPayments={this.state.showPayments}
            accountSelection={this.accountSelection}
            // selecteItem={this.selecteItem}
            singlePaymentSelection={this.singlePaymentSelection}
            openFilter={this.state.openFilter}
            openFilters={this.openFilters}
          />
          ) : null}
          {this.state.onSettleAmountConfirmation && (
            <ConfirmDialoag
              onCancel={this.onCancelSettle}
              onOk={this.onOKSettle}
              title={this.props.translate(
                "Do You want to Settle Outstanding Payment from Advance Payment?"
              )}
            />
          )}
        </Layout>
      );
    } else {
      fetch(
        "/api/session?app=3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05",
        {
          headers: { Accept: "application/json; odata=verbose" },
        }
      )
        .then((response) => {
          if (response.ok) {
            response.json().then((res) => {
              if (res.status === "success") {
                let userInfo = res.data;
                this.props.setActiveLanguage(
                  userInfo?.attributes?.lang || "en"
                );
                this.props.dispatch(logInUserInfo(userInfo));
              } else if (res?.statusCode === "440") {
                window.location.replace("/login");
              } else if (res.statusCode) {
                var err = res?.message.split(":");
                err[1] = err[1].replace(")", "");

                toast.error(this.props.translate(err[1]));
                this.props.navigate("/login");
              }
            });
          } else {
            this.props.navigate("/login");
            throw response;
          }
        })
        .catch((e) => {
          toast.error("somethingWentWrong");
        });
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers,
  cities: state.Cities?.cities || [],
});

export default connect(mapStateToProps)(withRoutes(Payment));
